import { createClient } from "@supabase/supabase-js";
export const supabase = createClient(
  __tactical_view.env.SUPABASE_URL,
  __tactical_view.env.SUPABASE_API_KEY,
  { persistSession: true, autoRefreshToken: true }
);
